/**
 * Texte des Dialers.
 *
 * Wichtig: die Zustandsnamen des Servers (AVAILABLE, RINGING, WRAP_UP …)
 * erscheinen nirgends in der Oberfläche. Ein Caller liest "Bereit" und
 * "Es klingelt" (00_product_overview.md, 02_navigation_ux_tutorial_i18n.md).
 */
export const deDialer = {
  'dialer.poolTitle': 'Anrufe annehmen',
  'dialer.poolHint':
    'Sobald Sie bereit sind, wählt das System für Sie und verbindet Sie mit Kunden, die abheben.',
  'dialer.assignedTitle': 'Ihre Datensätze anrufen',
  'dialer.assignedHint': 'Das System wählt der Reihe nach Ihre eigenen Datensätze an.',

  'dialer.acceptCalls': 'Anrufe annehmen',
  'dialer.start': 'Dialer starten',
  'dialer.stop': 'Dialer stoppen',
  'dialer.stopAccepting': 'Bereitschaft beenden',
  'dialer.pause': 'Pause',
  'dialer.resume': 'Weiter',
  'dialer.pauseHint': 'Nach einer Pause melden Sie sich wieder bewusst bereit.',

  // Zustände in Alltagssprache
  'dialer.state.OFFLINE': 'Nicht bereit',
  'dialer.state.ONLINE': 'Nicht bereit',
  'dialer.state.AVAILABLE': 'Bereit',
  'dialer.state.DIALING': 'Wählt',
  'dialer.state.RINGING': 'Es klingelt',
  'dialer.state.IN_CALL': 'Im Gespräch',
  'dialer.state.WRAP_UP': 'Nachbearbeitung',
  'dialer.state.PAUSED': 'Pause',
  'dialer.state.RECONNECTING': 'Verbindung wird wiederhergestellt',

  'dialer.manualTitle': 'Einzelnen Anruf führen',
  'dialer.manualHint': 'Für einen einzelnen Anruf, unabhängig vom Dialer.',
  'dialer.manualBlocked': 'Beenden Sie zuerst Ihre Bereitschaft, um einzeln anzurufen.',

  // Sicht des Admins auf eine laufende Kampagne
  'dialer.runtimeTitle': 'Telefonie in dieser Kampagne',
  'dialer.runtimeCallers': 'Bereite Caller',
  'dialer.runtimeWaiting': 'Kunden in der Warteschleife',
  'dialer.runtimeIdle': 'Gerade telefoniert niemand in dieser Kampagne.',
  'dialer.help.waiting':
    'Kunden, die abgehoben haben und auf einen freien Caller warten. Diese Zeit wird nicht berechnet.',

  // Wartemusik
  'queueMusic.title': 'Wartemusik',
  'queueMusic.hint': 'Eine Audiodatei je Kampagne, WAV oder MP3, bis 5 MB. Sie wird in Schleife gespielt.',
  'queueMusic.upload': 'Datei auswählen',
  'queueMusic.current': 'Hinterlegt',
  'queueMusic.remove': 'Entfernen',
  'queueMusic.none': 'Es ist keine eigene Wartemusik hinterlegt.',
  'queueMusic.saved': 'Die Wartemusik wurde gespeichert.',

  // Fehlermeldungen des Servers
  'error.campaign.stopped': 'Diese Kampagne ist gestoppt. Bitte wenden Sie sich an Ihre Administration.',
  'error.campaign.calls_in_progress':
    'In dieser Kampagne wird gerade telefoniert. Bitte warten Sie, bis die Gespräche beendet sind.',
  'error.queueMusic.empty': 'Bitte wählen Sie eine Audiodatei aus.',
  'error.queueMusic.too_large': 'Die Datei ist zu groß. Erlaubt sind bis zu 5 MB.',
  'error.queueMusic.invalid_format': 'Bitte laden Sie eine WAV- oder MP3-Datei hoch.',
} as const;
